import { useEffect, useRef } from "react";

const rows = [
  { feature: "Gotowe linki", spreadsheet: true, normal: false },
  { feature: "Kategorie produktów", spreadsheet: true, normal: false },
  { feature: "Oszczędność czasu", spreadsheet: "Wysoka", normal: "Niska" },
  { feature: "Lista popularnych produktów", spreadsheet: true, normal: false },
  { feature: "Poradniki i tutoriale", spreadsheet: true, normal: false },
  { feature: "QC zdjęcia", spreadsheet: true, normal: false },
  { feature: "Aktualizacje", spreadsheet: "Codziennie", normal: "Brak" },
];

export default function ComparisonSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const els = sectionRef.current?.querySelectorAll(".reveal-table");
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Kakobuy Spreadsheet vs Tradycyjne wyszukiwanie
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Zobacz dlaczego nasza baza produktów jest lepsza od ręcznego szukania
          </p>
        </div>

        <div className="reveal-table opacity-0 translate-y-6 transition-all duration-700 ease-out overflow-x-auto rounded-xl border border-background-200 bg-background-50">
          <table className="w-full min-w-[500px]">
            <thead>
              <tr className="border-b border-background-200">
                <th className="text-left px-4 md:px-6 py-3 md:py-4 text-sm font-semibold text-foreground-700 bg-background-100">
                  Funkcja
                </th>
                <th className="text-center px-4 md:px-6 py-3 md:py-4 text-sm font-semibold text-primary-700 bg-primary-50/50">
                  Kakobuy Spreadsheet
                </th>
                <th className="text-center px-4 md:px-6 py-3 md:py-4 text-sm font-semibold text-foreground-600 bg-background-100">
                  Normalne wyszukiwanie
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr
                  key={row.feature}
                  className={`border-b border-background-200/60 ${i % 2 === 1 ? "bg-background-50/50" : ""}`}
                >
                  <td className="px-4 md:px-6 py-3 md:py-4 text-sm text-foreground-800 font-medium">
                    {row.feature}
                  </td>
                  <td className="px-4 md:px-6 py-3 md:py-4 text-center text-sm">
                    {typeof row.spreadsheet === "boolean" ? (
                      row.spreadsheet ? (
                        <span className="inline-flex items-center gap-1 text-accent-600 font-medium">
                          <i className="ri-check-line" />
                          Tak
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1 text-foreground-400">
                          <i className="ri-close-line" />
                          Nie
                        </span>
                      )
                    ) : (
                      <span className="text-accent-600 font-medium">{row.spreadsheet}</span>
                    )}
                  </td>
                  <td className="px-4 md:px-6 py-3 md:py-4 text-center text-sm">
                    {typeof row.normal === "boolean" ? (
                      row.normal ? (
                        <span className="inline-flex items-center gap-1 text-accent-600 font-medium">
                          <i className="ri-check-line" />
                          Tak
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1 text-foreground-400">
                          <i className="ri-close-line" />
                          Nie
                        </span>
                      )
                    ) : (
                      <span className="text-foreground-500">{row.normal}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <style>{`
        .reveal-table.animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}